<template>
    <div class="wizard__wrap">
        <div class="wizard__block wizard__block--thank">
            <div class="wizard__block-title">
                The new SOW has been successfully uploaded. Thank you!
            </div>
        </div>
    </div>
</template>

<script>
import { scrollToTop } from "../../../helpers/_scrollToTop";

export default {
    name: "Wizard_Thank_You_Upload_SOW",
    methods: {},

    mounted() {
        scrollToTop();
    },
};
</script>
